/**
 * Converts a value to string.  If given `null` or `undefined`, an empty string is returned.
 * @function toString
 * @param value The value to convert.
 * @return {string} Returns converted string value.
 */
export default function toString(value) {
	if (value === null || value === undefined) return '';

	return value.toString();
}
